<div class="" *ngIf="!isLoggedIn">
  <nav class="navbar navbar-expand navbar-light middle-header pl-3 pr-3">
    <div class="container">
      <a class="navbar-brand" style="width: auto" routerLink="/home">
        <div class="logo-container">
          <img
            style="top: 0"
            class="logoImage"
            src="assets/latest/logo1.png"
            alt="logo"
            routerlinkActive
          />
          <!-- <span class="logo-text">Exobe</span> -->
        </div>
      </a>

      <!-- Mobile/Tablet Search Bar (Visible only on <= 991px) -->
      <div class="mobile-header-search">
        <div class="search-input-group">
          <input 
            type="text" 
            class="search-input" 
            placeholder="Search products, brands, categories..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput()"
            (keyup.enter)="onSearch()"
          />
          <button class="search-button" (click)="onSearch()">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>

      <!-- Hamburger Menu Button for Mobile/Tablet -->
      <button
        type="button"
        class="mobile-menu-toggle-header"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu"
      >
        <i class="fa fa-bars" *ngIf="!isMobileMenuOpen"></i>
        <i class="fa fa-times" *ngIf="isMobileMenuOpen"></i>
      </button>

      <!-- Desktop Navigation -->
      <div
        class="collapse navbar-collapse justify-content-end desktop-nav"
        id="navbarCollapse"
      >
        <!-- Search Bar -->
        <div class="header-search-container">
          <div class="search-input-group">
            <input 
              type="text" 
              class="search-input" 
              placeholder="Search products, brands, categories..."
              [(ngModel)]="searchQuery"
              (input)="onSearchInput()"
              (keyup.enter)="onSearch()"
            />
            <button class="search-button" (click)="onSearch()">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
        
        <div class="navbar-nav">
          <a
            class="nav-item nav-link home-nav-item"
            (click)="menuNavigateTo('home')"
            [ngClass]="{
              active: activebar == 'home' || activebar == 'retailer-home'
            }"
            *ngIf="loggedInUserType == 'CUSTOMER' || !isLoggedIn"
            routerLink="/home"
          >
            <span class="material-icons-outlined header-icon">home</span>
            <span class="nav-text">Home</span>
          </a>
          <a
            class="nav-item nav-link home-nav-item"
            *ngIf="
              isLoggedIn &&
              loggedInUserType == 'SERVICE_PROVIDER' &&
              SharingData &&
              userRequestStatus == 'APPROVED'
            "
            routerLink="/service-order-detail"
          >
            <span class="material-icons-outlined header-icon">home</span>
            <span class="nav-text">Home</span>
          </a>

          <a
            class="nav-item nav-link home-nav-item"
            *ngIf="
              isLoggedIn &&
              loggedInUserType == 'RETAILER' &&
              SharingData &&
              userRequestStatus == 'APPROVED'
            "
            routerLink="/retailer-home"
          >
            <span class="material-icons-outlined header-icon">home</span>
            <span class="nav-text">Home</span>
          </a>
          <a class="nav-item nav-link contact-nav-item" routerLink="/contactUs">
            <span class="material-icons-outlined header-icon">mail</span>
            <span class="nav-text">Contact</span>
          </a>
          <a class="nav-item nav-link wishlist-nav-item" (click)="menuNavigateTo('wishlist-customer')" [ngClass]="{ active: activebar == 'wishlist-customer' }">
            <!-- use outlined wishlist icon to match other outline icons -->
            <span class="material-icons-outlined header-icon">favorite_border</span>
            <span class="nav-text">Wishlist</span>
          </a>
          <a class="nav-item nav-link cart-nav-item" (click)="menuNavigateTo('addtoCart-customer')" [ngClass]="{ active: activebar == 'addtoCart-customer' }">
            <span class="material-icons-outlined header-icon">shopping_cart</span>
            <span class="nav-text">Cart</span>
            <span class="cart-badge" *ngIf="isLoggedIn && totalItemsInShoppingBag > 0">{{ totalItemsInShoppingBag }}</span>
          </a>
          <div *ngIf="!isLoggedIn" class="nav-item dropdown account-nav-item">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
            >
              <span class="material-icons-outlined header-icon">person</span>
              <span class="nav-text">Account</span>
              <i class="fa fa-chevron-down dropdown-arrow"></i>
            </a>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="loginNavigate('CUSTOMER')"
                >Customer Login</a
              >
              <a class="dropdown-item" (click)="loginNavigate('RETAILER')"
                >Retailer Login</a
              >
              <a
                class="dropdown-item"
                (click)="loginNavigate('SERVICE_PROVIDER')"
                style="border-bottom: 2px solid #BE0119 !important"
                >Service Provider Login</a
              >
            </div>
          </div>
        </div>
        <div class="navbar-nav">
          <div class="navbar-social-icon">
            <div
              *ngIf="
                isLoggedIn &&
                (loggedInUserType == 'CUSTOMER' ||
                  loggedInUserType == 'RETAILER') &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
              style="position: relative;"
            >
              <a class="nav-link iconClass">
                <i
                  class="fa fa-shopping-bag"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="My Cart"
                  aria-hidden="true"
                  (click)="menuNavigateTo('addtoCart-customer')"
                  [ngClass]="{ active: activebar == 'addtoCart-customer' }"
                ></i>
                <span class="cart-badge-icon" *ngIf="totalItemsInShoppingBag > 0">{{ totalItemsInShoppingBag }}</span>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                (loggedInUserType == 'CUSTOMER' ||
                  loggedInUserType == 'RETAILER') &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a class="nav-link iconClass">
                <i
                  class="fa fa-heart"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Wishlist"
                  (click)="menuNavigateTo('wishlist-customer')"
                  [ngClass]="{ active: activebar == 'wishlist-customer' }"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'RETAILER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a class="nav-link iconClass">
                <i
                  class="fa fa-first-order"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Orders"
                  (click)="menuNavigateTo('retailer-order-list')"
                  [ngClass]="{ active: activebar == 'retailer-order-list' }"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'RETAILER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a class="nav-link iconClass">
                <img
                  src="assets/img/product.png"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Products"
                  style="width: 25px"
                  (click)="menuNavigateTo('retailer-product-list')"
                  [ngClass]="{ active: activebar == 'retailer-product-list' }"
                />
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'RETAILER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item dropdown"
            >
              <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                <img
                  src="assets/img/deal1.png"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Deals"
                  style="width: 34px"
                  [ngClass]="{ active: activebar == 'retailer-deal-list' }"
                />
              </a>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('retailer-deal-list')"
                  >Deals to customer</a
                >
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('customer-product-deal-list')"
                  >Deals from wholesalers</a
                >
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('deal-service')"
                  >Deals on bookings</a
                >
              </div>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'CUSTOMER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a
                class="nav-link iconClass"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Bookings"
              >
                <i
                  class="fa fa-wrench"
                  (click)="menuNavigateTo('customer-service-list')"
                  [ngClass]="{ active: activebar == 'customer-service-list' }"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'CUSTOMER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a
                class="nav-link iconClass"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Categories"
              >
                <i
                  class="fa fa-list-alt"
                  (click)="menuNavigateTo('customer-category-list')"
                  [ngClass]="{ active: activebar == 'customer-category-list' }"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'CUSTOMER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item dropdown"
            >
              <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                <img
                  src="assets/img/deal1.png"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Deals"
                  style="width: 34px"
                />
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item" (click)="menuNavigateTo('deal-list')"
                  >Deals on products</a
                >
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('deal-service')"
                  >Deals on bookings</a
                >
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('deal-service-list')"
                  >My Bookings History</a
                >
              </div>
            </div>

            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'RETAILER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item dropdown"
            >
              <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                <i
                  class="fa fa-history"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Payment History"
                  aria-hidden="true"
                ></i>
              </a>
              <div class="dropdown-menu">
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('reatiler-payment-customer')"
                  >Payment from customer</a
                >
                <a
                  class="dropdown-item"
                  (click)="menuNavigateTo('reatiler-payment-wholesaler')"
                  >Payment to wholesalers</a
                >
              </div>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'SERVICE_PROVIDER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a
                class="nav-link iconClass"
                style="cursor: pointer"
                data-toggle="tooltip"
                data-placement="bottom"
                title="My Bookings"
              >
                <img
                  style="width: 23px"
                  (click)="menuNavigateTo('service-provider-request-services')"
                  src="assets/img/request.png"
                />
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'SERVICE_PROVIDER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a
                class="nav-link iconClass"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Deals to customers"
              >
                <i
                  class="fa fa-gift"
                  (click)="menuNavigateTo('service-provider-deals-to-customer')"
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'SERVICE_PROVIDER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <a
                class="nav-link iconClass"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Payment From Customers"
              >
                <i
                  class="fa fa-history"
                  (click)="
                    menuNavigateTo('service-provider-payment-from-customers')
                  "
                  aria-hidden="true"
                ></i>
              </a>
            </div>
            <div
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'SERVICE_PROVIDER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              class="nav-item"
            >
              <div
                class="main-menu-text"
                (click)="menuNavigateTo('services'); setServicesMenuClick()"
                [ngClass]="{ active: activebar == 'services' }"
              >
                <p>Services</p>
              </div>
            </div>

            <div *ngIf="isLoggedIn" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-user first-profile-ico" aria-hidden="true"></i>
              </a>
              <div
                class="dropdown-menu"
                *ngIf="userRequestStatus == 'APPROVED'"
              >
                <a
                  class="dropdown-item"
                  *ngIf="SharingData"
                  routerLink="/customer-profile"
                  >My Profile</a
                >
                <a
                  class="dropdown-item"
                  *ngIf="
                    (loggedInUserType == 'CUSTOMER' ||
                      loggedInUserType == 'RETAILER') &&
                    SharingData &&
                    userRequestStatus == 'APPROVED'
                  "
                  routerLink="/customer-order-history"
                  >Order History</a
                >

                <a
                  class="dropdown-item"
                  *ngIf="
                    (loggedInUserType == 'CUSTOMER' ||
                      loggedInUserType == 'RETAILER') &&
                    SharingData &&
                    userRequestStatus == 'APPROVED'
                  "
                  routerLink="/customer-product-enquiry"
                  >Product Enquiry</a
                >
                <a
                  class="dropdown-item"
                  *ngIf="
                    (loggedInUserType == 'CUSTOMER' ||
                      loggedInUserType == 'RETAILER') &&
                    SharingData &&
                    userRequestStatus == 'APPROVED'
                  "
                  routerLink="/customer-address-list"
                  >Address</a
                >
                <a class="dropdown-item" (click)="logOutModal()">Logout</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <!-- Mobile Menu Overlay -->
  <div class="mobile-menu-overlay-header" [class.show]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

  <!-- Mobile Side Menu Drawer -->
  <div class="mobile-menu-drawer" [class.open]="isMobileMenuOpen">
    <div class="mobile-menu-header">
      <div class="mobile-menu-logo">
        <img src="assets/latest/logo1.png" alt="Exobe" class="mobile-logo-image" />
      </div>
      <button class="mobile-menu-close-btn" (click)="toggleMobileMenu()" aria-label="Close menu">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="mobile-menu-content">
      <!-- Navigation Links -->
      <nav class="mobile-nav-links">
        <a
          class="mobile-nav-link"
          (click)="menuNavigateTo('home'); toggleMobileMenu()"
          [ngClass]="{ active: activebar == 'home' || activebar == 'retailer-home' }"
          routerLink="/home"
        >
          <i class="fa fa-home"></i>
          <span>Home</span>
        </a>

        <a 
          class="mobile-nav-link" 
          (click)="toggleMobileMenu()"
          routerLink="/contactUs"
        >
          <i class="fa fa-envelope"></i>
          <span>Contact</span>
        </a>

        <a 
          class="mobile-nav-link" 
          (click)="menuNavigateTo('wishlist-customer'); toggleMobileMenu()" 
          [ngClass]="{ active: activebar == 'wishlist-customer' }"
        >
          <i class="fa fa-heart"></i>
          <span>Wishlist</span>
        </a>

        <a 
          class="mobile-nav-link" 
          (click)="menuNavigateTo('addtoCart-customer'); toggleMobileMenu()" 
          [ngClass]="{ active: activebar == 'addtoCart-customer' }"
        >
          <i class="fa fa-shopping-cart"></i>
          <span>Cart</span>
          <span class="mobile-cart-badge" *ngIf="isLoggedIn && totalItemsInShoppingBag > 0">{{ totalItemsInShoppingBag }}</span>
        </a>

        <!-- Account Dropdown Section -->
        <div class="mobile-account-section">
          <div class="mobile-account-header" (click)="toggleMobileAccountMenu()">
            <i class="fa fa-user"></i>
            <span>Account</span>
            <i class="fa fa-chevron-down" [class.rotate]="isMobileAccountMenuOpen"></i>
          </div>
          <div class="mobile-account-dropdown" [class.open]="isMobileAccountMenuOpen">
            <a class="mobile-account-link" (click)="loginNavigate('CUSTOMER'); toggleMobileMenu()">
              Customer Login
            </a>
            <a class="mobile-account-link" (click)="loginNavigate('RETAILER'); toggleMobileMenu()">
              Retailer Login
            </a>
            <a class="mobile-account-link" (click)="loginNavigate('SERVICE_PROVIDER'); toggleMobileMenu()">
              Service Provider Login
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</div>
<header
  *ngIf="isLoggedIn"
  [ngClass]="{ 'd-flex': !isMobile, 'd-block': isMobile }"
>
  <div class="header-wide">
    <nav class="nav-flex">
      <div class="logo-box">
        <ng-container *ngIf="flagMe">
          <a
            class="navbar-brand"
            *ngIf="loggedInUserType == 'CUSTOMER' || !isLoggedIn"
            (click)="navigateHome('/home')"
          >
            <div class="logo-container">
              <img
                class="logoImage"
                src="assets/latest/logo1.png"
                alt="logo"
                routerlinkActive
              />
              <!-- <span class="logo-text">Exobe</span> -->
            </div>
          </a>
          <a
            class="navbar-brand"
            *ngIf="isLoggedIn && loggedInUserType == 'RETAILER'"
            (click)="navigateHome('/retailer-home')"
          >
            <div class="logo-container">
              <img
                class="logoImage"
                src="assets/latest/logo1.png"
                alt="logo"
                routerlinkActive
              />
              <!-- <span class="logo-text">Exobe</span> -->
            </div>
          </a>
          <a
            class="navbar-brand"
            *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER'"
            (click)="navigateHome('/service-order-detail')"
          >
            <div class="logo-container">
              <img
                class="logoImage"
                src="assets/latest/logo1.png"
                alt="logo"
                routerlinkActive
              />
              <!-- <span class="logo-text">Exobe</span> -->
            </div>
          </a>
        </ng-container>
        <ng-container *ngIf="!flagMe">
          <a
            class="navbar-brand"
            style="margin-bottom: 38px"
            (click)="navigateHome('/home')"
          >
            <div class="logo-container">
              <img
                class="logoImage"
                src="assets/latest/logo1.png"
                alt="logo"
                routerlinkActive
              />
              <!-- <span class="logo-text">Exobe</span> -->
            </div>
          </a>
        </ng-container>
      </div>
      <!-- <div class="right-container d-flex justify-content-end"> -->
      <!-- <div class="menu-item">
          <div class="menu-text" style="min-width: 0;">
            <p [routerLink]="['/contactUs']">Help</p>
          </div>
          <img src="assets/latest/header-line.svg" class="header-line" alt="" />
        </div> -->
      <!-- <div class="menu-item">
          <div class="menu-text">
            <p (click)="navigateToAccount()">Account</p>
          </div>
          <img src="assets/latest/header-line.svg" class="header-line" alt="" />
        </div> -->
      <!-- <div class="menu-item" *ngIf="
            isLoggedIn &&
            (loggedInUserType == 'CUSTOMER' ||
              loggedInUserType == 'RETAILER') &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          ">
          <div class="menu-text" (click)="menuNavigateTo('wishlist-customer')"
            [ngClass]="{ active: activebar == 'wishlist-customer' }">
            <p>Wishlist</p>
          </div>
          <img src="assets/latest/header-line.svg" class="header-line" alt="" />
        </div> -->
      <!-- <div class="menu-item" *ngIf="
            isLoggedIn &&
            (loggedInUserType == 'CUSTOMER' ||
              loggedInUserType == 'RETAILER') &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          ">
          <div class="cart-logo" (click)="menuNavigateTo('addtoCart-customer')"
            [ngClass]="{ active: activebar == 'addtoCart-customer' }">
            <img src="assets/latest/cart.png" alt="" srcset="" />
          </div>
        </div> -->
      <!-- </div> -->
      <!-- Search Bar -->
      <div class="header-search-container">
        <div class="search-input-group">
          <input 
            type="text" 
            class="search-input" 
            placeholder="Search products, brands, categories..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput()"
            (keyup.enter)="onSearch()"
          />
          <button class="search-button" (click)="onSearch()">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>

      <!-- Mobile Menu Toggle Button -->
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()">
        <i class="fa fa-bars"></i>
      </button>

      <!-- Mobile Menu Overlay -->
      <div class="mobile-menu-overlay" [class.show]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

      <!-- Navigation Menu (Desktop) -->
      <div class="nav-menu">

        <!-- Mobile Profile Section (Shows at top on mobile) -->
        <div class="mobile-profile-section">
          <div *ngIf="isLoggedIn && flagMe" class="mobile-profile-dropdown">
            <div class="mobile-profile-header" (click)="toggleMobileProfileDropdown()">
              <div class="mobile-profile-container">
                <img
                  class="mobile-profileImage"
                  [src]="profileData?.profilePic || 'assets/latest/profile1.png'"
                  alt="Profile"
                />
                <div class="mobile-profile-info" *ngIf="profileData">
                  <p class="mobile-profile-name">{{profileData?.firstName}} {{profileData?.lastName}}</p>
                  <p class="mobile-profile-email">{{profileData?.email}}</p>
                </div>
              </div>
              <i class="fa" [ngClass]="isMobileProfileOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
            
            <!-- Mobile Profile Dropdown Menu -->
            <div class="mobile-profile-menu" [class.show]="isMobileProfileOpen" *ngIf="userRequestStatus == 'APPROVED'">
              <a
                class="mobile-profile-menu-item"
                *ngIf="SharingData"
                routerLink="/customer-profile"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-user"></i>
                My Profile
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  (loggedInUserType == 'CUSTOMER' ||
                    loggedInUserType == 'RETAILER') &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/customer-order-history"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-shopping-bag"></i>
                Order History
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  (loggedInUserType == 'CUSTOMER' ||
                    loggedInUserType == 'RETAILER') &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/intrested-price"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-bullhorn"></i>
                Campaign Participation
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  loggedInUserType == 'SERVICE_PROVIDER' &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/service-order-rejected-detail"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-ban"></i>
                Rejected Orders
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  loggedInUserType == 'SERVICE_PROVIDER' &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/service-campaign-list"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-bullhorn"></i>
                Campaign Issued
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  (loggedInUserType == 'CUSTOMER' ||
                    loggedInUserType == 'RETAILER') &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/customer-product-enquiry"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-question-circle"></i>
                Product Enquiry
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  loggedInUserType == 'RETAILER' &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/campaign-list"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-bullhorn"></i>
                Campaign Issued
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  (loggedInUserType == 'CUSTOMER' ||
                    loggedInUserType == 'RETAILER') &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/customer-wallet"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-credit-card"></i>
                My Wallet
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="
                  (loggedInUserType == 'CUSTOMER' ||
                    loggedInUserType == 'RETAILER') &&
                  SharingData &&
                  userRequestStatus == 'APPROVED'
                "
                routerLink="/customer-address-list"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-map-marker"></i>
                Address
              </a>
              <a class="mobile-profile-menu-item" (click)="openRoleModal()">
                <i class="fa fa-exchange"></i>
                Switch role
              </a>
              <a
                class="mobile-profile-menu-item"
                [routerLink]="['/contactUs']"
                (click)="toggleMobileMenu()"
              >
                <i class="fa fa-envelope"></i>
                Help
              </a>
              <a
                class="mobile-profile-menu-item"
                (click)="menuNavigateTo('wishlist-customer'); toggleMobileMenu()"
              >
                <i class="fa fa-heart"></i>
                Wishlist
              </a>
              <a
                class="mobile-profile-menu-item"
                *ngIf="subType != 'FIELD_ENTITY' && isSubService"
                (click)="navigateToRejected(); toggleMobileMenu()"
              >
                <i class="fa fa-times-circle"></i>
                Rejected Order
              </a>
              <a class="mobile-profile-menu-item" (click)="logOutModal(); toggleMobileMenu()">
                <i class="fa fa-sign-out"></i>
                Logout
              </a>
            </div>
          </div>
        </div>

        <div class="main-menu-container">
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('home'); toggleMobileMenu()"
              [ngClass]="{
                active: activebar == 'home' || activebar == 'retailer-home'
              }"
              *ngIf="loggedInUserType == 'CUSTOMER'"
              routerLink="/home"
            >
              <p>Home</p>
            </div>
            <div
              class="main-menu-text"
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'SERVICE_PROVIDER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              (click)="navigateHome('/service-order-detail'); toggleMobileMenu()"
            >
              <p>Home</p>
            </div>
            <div
              class="main-menu-text"
              *ngIf="
                isLoggedIn &&
                loggedInUserType == 'RETAILER' &&
                SharingData &&
                userRequestStatus == 'APPROVED'
              "
              routerLink="/retailer-home"
              (click)="toggleMobileMenu()"
            >
              <p>Home</p>
            </div>
          </div>
          <div class="border underline"
            *ngIf="activebar == 'home' || activebar == 'retailer-home'"
          ></div>
        </div>

        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('retailer-product-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'retailer-product-list' }"
            >
              <p>Product</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'retailer-product-list'"
          ></div>
        </div>
        <!-- service provider -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'SERVICE_PROVIDER' &&
            SharingData &&
            userRequestStatus == 'APPROVED' &&
            !isSubService
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('service-provider-request-services'); toggleMobileMenu()"
              [ngClass]="{
                active: activebar == 'service-provider-request-services'
              }"
            >
              <p>Requested Service</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'service-provider-request-services'"
          ></div>
        </div>
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'SERVICE_PROVIDER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              [routerLink]="['/transaction-history']"
              (click)="toggleMobileMenu()"
              [ngClass]="{
                active: activebar == 'transaction-history'
              }"
            >
              <p>Transaction History</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'transaction-history'"
          ></div>
        </div>

        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              [routerLink]="['/transaction-history']"
              (click)="toggleMobileMenu()"
              [ngClass]="{
                active: activebar == 'transaction-history'
              }"
            >
              <p>Transaction History</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'transaction-history'"
          ></div>
        </div>
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'SERVICE_PROVIDER' &&
            SharingData &&
            userRequestStatus == 'APPROVED' &&
            !isSubService
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('service-provider-deals-to-customer'); toggleMobileMenu()"
              [ngClass]="{
                active: activebar == 'service-provider-deals-to-customer'
              }"
            >
              <p>Deals</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'service-provider-deals-to-customer'"
          ></div>
        </div>
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'SERVICE_PROVIDER' &&
            SharingData &&
            userRequestStatus == 'APPROVED' &&
            !isSubService
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="
                menuNavigateTo('service-provider-payment-from-customers'); toggleMobileMenu()
              "
              [ngClass]="{
                active: activebar == 'service-provider-payment-from-customers'
              }"
            >
              <p>Payment</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'service-provider-payment-from-customers'"
          ></div>
        </div>
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'SERVICE_PROVIDER' &&
            SharingData &&
            userRequestStatus == 'APPROVED' &&
            !isSubService
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('services'); setServicesMenuClick(); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'services' }"
            >
              <p>Services</p>
            </div>
          </div>
          <div class="border underline" *ngIf="activebar == 'services'"></div>
        </div>

        <!-- order start -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('retailer-order-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'retailer-order-list' }"
            >
              <p>Orders</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'retailer-order-list'"
          ></div>
        </div>
        <!-- order end -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'CUSTOMER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div
              class="main-menu-text"
              (click)="menuNavigateTo('customer-category-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'customer-category-list' }"
            >
              <p>Category</p>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'customer-category-list'"
          ></div>
        </div>

        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'CUSTOMER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div class="main-menu-text">
              <!-- <p>Bookings</p> -->
              <div
                class="nav-item dropdown"
                [ngClass]="{ active: activebar == 'customer-service-list' }"
              >
                <a
                  class="nav-link dropdown-toggle dealsRetailer"
                  data-toggle="dropdown"
                >
                  Bookings
                </a>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('customer-service-list'); toggleMobileMenu()"
                    >Booking Categories</a
                  >
                  <!-- <a class="dropdown-item" (click)="menuNavigateTo('deal-service')">Deals on bookings</a> -->
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('deal-service-list'); toggleMobileMenu()"
                    >My Bookings History</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="
              activebar == 'customer-service-list' ||
              activebar == 'deal-service-list'
            "
          ></div>
        </div>
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div class="main-menu-text">
              <!-- <p>Bookings</p> -->
              <div
                class="nav-item dropdown"
                [ngClass]="{ active: activebar == 'customer-service-list' }"
              >
                <a
                  class="nav-link dropdown-toggle dealsRetailer"
                  data-toggle="dropdown"
                >
                  Bookings
                </a>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('customer-service-list'); toggleMobileMenu()"
                    >Category
                  </a>
                  <!-- <a class="dropdown-item" (click)="menuNavigateTo('deal-service')">Deals on bookings</a> -->
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('deal-service-list'); toggleMobileMenu()"
                    >My Bookings History</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="
              activebar == 'customer-service-list' ||
              activebar == 'deal-service-list'
            "
          ></div>
        </div>
        <!-- reatiler deals  -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div class="main-menu-text">
              <div
                class="nav-item dropdown"
                [ngClass]="{ active: activebar == 'retailer-deal-list' }"
              >
                <a
                  class="nav-link dropdown-toggle dealsRetailer"
                  data-toggle="dropdown"
                >
                  Deals
                </a>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('retailer-deal-list'); toggleMobileMenu()"
                    >Deals to customer</a
                  >
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('customer-product-deal-list'); toggleMobileMenu()"
                    >Deals from wholesalers</a
                  >
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('deal-service'); toggleMobileMenu()"
                    >Deals on bookings</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="
              activebar == 'retailer-deal-list' ||
              activebar == 'customer-product-deal-list' ||
              activebar == 'deal-service'
            "
          ></div>
        </div>
        <!-- payment reatiler start -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'RETAILER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div class="main-menu-text">
              <div
                class="nav-item dropdown"
                [ngClass]="{ active: activebar == 'retailer-deal-list' }"
              >
                <a
                  class="nav-link dropdown-toggle dealsRetailer"
                  data-toggle="dropdown"
                >
                  Payment
                </a>
                <div class="dropdown-menu">
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('reatiler-payment-customer'); toggleMobileMenu()"
                    >Payment from customer</a
                  >
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('reatiler-payment-wholesaler'); toggleMobileMenu()"
                    >Payment to wholesalers</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="
              activebar == 'reatiler-payment-customer' ||
              activebar == 'reatiler-payment-wholesaler'
            "
          ></div>
        </div>
        <!-- payment reatiler end  -->
        <!-- customner deals -->
        <div
          class="main-menu-container"
          *ngIf="
            isLoggedIn &&
            loggedInUserType == 'CUSTOMER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          "
        >
          <div class="main-menu-item">
            <div class="main-menu-text">
              <div
                class="nav-item dropdown"
                [ngClass]="{ active: activebar == 'deal-list' }"
              >
                <a
                  class="nav-link dropdown-toggle dealsRetailer"
                  data-toggle="dropdown"
                >
                  Deals
                </a>
                <div class="dropdown-menu">
                  <a class="dropdown-item" (click)="menuNavigateTo('deal-list'); toggleMobileMenu()"
                    >Deals on products</a
                  >
                  <a
                    class="dropdown-item"
                    (click)="menuNavigateTo('deal-service'); toggleMobileMenu()"
                    >Deals on bookings</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="border underline"
            *ngIf="activebar == 'deal-list' || activebar == 'deal-service'"
          ></div>
        </div>
        <!-- <div class="main-menu-container" *ngIf="
            isLoggedIn &&
            loggedInUserType == 'CUSTOMER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          ">
            <div class="nav-item dropdown" style="cursor: pointer;" (click)="menuNavigateTo('wishlist-customer')"
              [ngClass]="{ active: activebar == 'wishlist-customer' }">
              <p class="nav-link dropdown-toggle dealsRetailer">Wishlist</p>
            </div>
        </div> -->
        <!-- <div class="main-menu-container" *ngIf="
            isLoggedIn &&
            loggedInUserType == 'CUSTOMER' &&
            SharingData &&
            userRequestStatus == 'APPROVED'
          ">
          <div class="menu-item" *ngIf="
              isLoggedIn &&
              (loggedInUserType == 'CUSTOMER' ||
                loggedInUserType == 'RETAILER') &&
              SharingData &&
              userRequestStatus == 'APPROVED'
            ">
            <div class="menu-text" (click)="menuNavigateTo('wishlist-customer')"
              [ngClass]="{ active: activebar == 'wishlist-customer' }">
              <p>Wishlist</p>
            </div>
          </div>
        </div> -->
        <div class="main-menu-container">
          <div class="main-menu-item">
            <div class="main-menu-text d-flex align-items-center">
              <!-- Cart Icon -->
              <div 
                class="cart-icon-container"
                *ngIf="isLoggedIn && (loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'"
                (click)="menuNavigateTo('addtoCart-customer')"
                [ngClass]="{ active: activebar == 'addtoCart-customer' }"
              >
                <div class="cart-logo" style="margin: 0; position: relative; cursor: pointer;">
                  <img src="assets/latest/cart.png" alt="Cart" />
                  <span class="cart-badge-image" *ngIf="totalItemsInShoppingBag > 0">{{ totalItemsInShoppingBag }}</span>
                </div>
              </div>
              <!-- <p class="userName">{{profileData?.firstName}}</p> -->
              <div *ngIf="isLoggedIn && flagMe" class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown">
                  <!-- <i class="fa fa-user first-profile-ico" aria-hidden="true"></i> -->
                  <div class="profile-image-wrapper">
                    <img
                      class="profileImageBox"
                      [src]="
                        profileData?.profilePic || 'assets/latest/profile1.png'
                      "
                      alt=""
                    />
                    <span class="online-indicator" *ngIf="isLoggedIn"></span>
                  </div>
                </a>
                <div
                  class="dropdown-menu"
                  *ngIf="userRequestStatus == 'APPROVED'"
                >
                  <a
                    class="dropdown-item"
                    *ngIf="SharingData"
                    routerLink="/customer-profile"
                    >My Profile</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      (loggedInUserType == 'CUSTOMER' ||
                        loggedInUserType == 'RETAILER') &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/customer-order-history"
                    >Order History</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      (loggedInUserType == 'CUSTOMER' ||
                        loggedInUserType == 'RETAILER') &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/intrested-price"
                    >Campaign Participation</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      loggedInUserType == 'SERVICE_PROVIDER' &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/service-order-rejected-detail"
                    >Rejected Orders</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      loggedInUserType == 'SERVICE_PROVIDER' &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/service-campaign-list"
                    >Campaign Issued</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      (loggedInUserType == 'CUSTOMER' ||
                        loggedInUserType == 'RETAILER') &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/customer-product-enquiry"
                    >Product Enquiry</a
                  >

                  <a
                    class="dropdown-item"
                    *ngIf="
                      loggedInUserType == 'RETAILER' &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/campaign-list"
                    >Campaign Issued</a
                  >

                  <!-- <a class="dropdown-item" *ngIf="
                        loggedInUserType == 'RETAILER' &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    " routerLink="/retailer-requested-price">Requested Price</a> -->
                  <a
                    class="dropdown-item"
                    *ngIf="
                      (loggedInUserType == 'CUSTOMER' ||
                        loggedInUserType == 'RETAILER') &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/customer-wallet"
                    >My Wallet</a
                  >
                  <a
                    class="dropdown-item"
                    *ngIf="
                      (loggedInUserType == 'CUSTOMER' ||
                        loggedInUserType == 'RETAILER') &&
                      SharingData &&
                      userRequestStatus == 'APPROVED'
                    "
                    routerLink="/customer-address-list"
                    >Address</a
                  >
                  <a class="dropdown-item" (click)="openRoleModal()"
                    >Switch role</a
                  >
                  <p
                    class="dropdown-item"
                    style="margin: 0"
                    [routerLink]="['/contactUs']"
                  >
                    Help
                  </p>
                  <!-- <div class="dropdown-item" (click)="menuNavigateTo('wishlist-customer')"
                    [ngClass]="{ active: activebar == 'wishlist-customer' }"> -->
                  <p
                    class="dropdown-item"
                    style="margin: 0"
                    (click)="menuNavigateTo('wishlist-customer')"
                  >
                    Wishlist
                  </p>
                  <!-- </div> -->
                  <a
                    class="dropdown-item"
                    *ngIf="subType != 'FIELD_ENTITY' && isSubService"
                    (click)="navigateToRejected()"
                    >Rejected Order</a
                  >
                  <a class="dropdown-item" (click)="logOutModal()">Logout</a>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="border underline"></div> -->
        </div>
      </div>

      <!-- Mobile Side Menu Drawer -->
      <div class="mobile-menu-drawer-logged-in" [class.open]="isMobileMenuOpen">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <img src="assets/latest/logo1.png" alt="Exobe" class="mobile-logo-image" />
          </div>
          <button class="mobile-menu-close-btn" (click)="toggleMobileMenu()" aria-label="Close menu">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="mobile-menu-content">
          <!-- Profile Section -->
          <div class="mobile-profile-section">
            <div *ngIf="isLoggedIn && flagMe" class="mobile-profile-dropdown">
              <div class="mobile-profile-header" (click)="toggleMobileProfileDropdown()">
                <div class="mobile-profile-container">
                  <div class="mobile-profile-image-wrapper">
                    <img
                      class="mobile-profileImage"
                      [src]="profileData?.profilePic || 'assets/latest/profile1.png'"
                      alt="Profile"
                    />
                    <span class="online-indicator mobile-online-indicator" *ngIf="isLoggedIn"></span>
                  </div>
                  <div class="mobile-profile-info" *ngIf="profileData">
                    <p class="mobile-profile-name">{{profileData?.firstName}} {{profileData?.lastName}}</p>
                    <p class="mobile-profile-email">{{profileData?.email}}</p>
                  </div>
                </div>
                <i class="fa" [ngClass]="isMobileProfileOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </div>
              
              <!-- Mobile Profile Dropdown Menu -->
              <div class="mobile-profile-menu" [class.show]="isMobileProfileOpen" *ngIf="userRequestStatus == 'APPROVED'">
                <a class="mobile-profile-menu-item" *ngIf="SharingData" routerLink="/customer-profile" (click)="toggleMobileMenu()">
                  <i class="fa fa-user"></i> My Profile
                </a>
                <a class="mobile-profile-menu-item" *ngIf="(loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'" routerLink="/customer-order-history" (click)="toggleMobileMenu()">
                  <i class="fa fa-shopping-bag"></i> Order History
                </a>
                <a class="mobile-profile-menu-item" *ngIf="(loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'" routerLink="/intrested-price" (click)="toggleMobileMenu()">
                  <i class="fa fa-bullhorn"></i> Campaign Participation
                </a>
                <a class="mobile-profile-menu-item" *ngIf="loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'" routerLink="/service-order-rejected-detail" (click)="toggleMobileMenu()">
                  <i class="fa fa-ban"></i> Rejected Orders
                </a>
                <a class="mobile-profile-menu-item" *ngIf="loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'" routerLink="/service-campaign-list" (click)="toggleMobileMenu()">
                  <i class="fa fa-bullhorn"></i> Campaign Issued
                </a>
                <a class="mobile-profile-menu-item" *ngIf="(loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'" routerLink="/customer-product-enquiry" (click)="toggleMobileMenu()">
                  <i class="fa fa-question-circle"></i> Product Enquiry
                </a>
                <a class="mobile-profile-menu-item" *ngIf="loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'" routerLink="/campaign-list" (click)="toggleMobileMenu()">
                  <i class="fa fa-bullhorn"></i> Campaign Issued
                </a>
                <a class="mobile-profile-menu-item" *ngIf="(loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'" routerLink="/customer-wallet" (click)="toggleMobileMenu()">
                  <i class="fa fa-credit-card"></i> My Wallet
                </a>
                <a class="mobile-profile-menu-item" *ngIf="(loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'" routerLink="/customer-address-list" (click)="toggleMobileMenu()">
                  <i class="fa fa-map-marker"></i> Address
                </a>
                <a class="mobile-profile-menu-item" (click)="openRoleModal()">
                  <i class="fa fa-exchange"></i> Switch role
                </a>
                <a class="mobile-profile-menu-item" [routerLink]="['/contactUs']" (click)="toggleMobileMenu()">
                  <i class="fa fa-envelope"></i> Help
                </a>
                <a class="mobile-profile-menu-item" (click)="menuNavigateTo('wishlist-customer'); toggleMobileMenu()">
                  <i class="fa fa-heart"></i> Wishlist
                </a>
                <a class="mobile-profile-menu-item" *ngIf="subType != 'FIELD_ENTITY' && isSubService" (click)="navigateToRejected(); toggleMobileMenu()">
                  <i class="fa fa-times-circle"></i> Rejected Order
                </a>
                <a class="mobile-profile-menu-item" (click)="logOutModal(); toggleMobileMenu()">
                  <i class="fa fa-sign-out"></i> Logout
                </a>
              </div>
            </div>
          </div>

          <!-- Navigation Links -->
          <nav class="mobile-nav-links">
            <!-- Home -->
            <a
              class="mobile-nav-link"
              (click)="menuNavigateTo('home'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'home' || activebar == 'retailer-home' }"
              *ngIf="loggedInUserType == 'CUSTOMER'"
              routerLink="/home"
            >
              <i class="fa fa-home"></i>
              <span>Home</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="navigateHome('/service-order-detail'); toggleMobileMenu()"
            >
              <i class="fa fa-home"></i>
              <span>Home</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'"
              routerLink="/retailer-home"
              (click)="toggleMobileMenu()"
            >
              <i class="fa fa-home"></i>
              <span>Home</span>
            </a>

            <!-- Category -->
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'CUSTOMER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('customer-category-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'customer-category-list' }"
            >
              <i class="fa fa-list-alt"></i>
              <span>Category</span>
            </a>

            <!-- Bookings -->
            <div class="mobile-account-section">
              <div class="mobile-account-header" (click)="toggleMobileBookingsMenu()" *ngIf="isLoggedIn && loggedInUserType == 'CUSTOMER' && SharingData && userRequestStatus == 'APPROVED'">
                <i class="fa fa-wrench"></i>
                <span>Bookings</span>
                <i class="fa fa-chevron-down" [class.rotate]="isMobileBookingsMenuOpen"></i>
              </div>
              <div class="mobile-account-dropdown" [class.open]="isMobileBookingsMenuOpen" *ngIf="isLoggedIn && loggedInUserType == 'CUSTOMER' && SharingData && userRequestStatus == 'APPROVED'">
                <a class="mobile-account-link" (click)="menuNavigateTo('customer-service-list'); toggleMobileMenu()">
                  Booking Categories
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('deal-service-list'); toggleMobileMenu()">
                  My Bookings History
                </a>
              </div>
            </div>

            <!-- Deals -->
            <div class="mobile-account-section" *ngIf="isLoggedIn && loggedInUserType == 'CUSTOMER' && SharingData && userRequestStatus == 'APPROVED'">
              <div class="mobile-account-header" (click)="toggleMobileDealsMenu()">
                <i class="fa fa-gift"></i>
                <span>Deals</span>
                <i class="fa fa-chevron-down" [class.rotate]="isMobileDealsMenuOpen"></i>
              </div>
              <div class="mobile-account-dropdown" [class.open]="isMobileDealsMenuOpen">
                <a class="mobile-account-link" (click)="menuNavigateTo('deal-list'); toggleMobileMenu()">
                  Deals on products
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('deal-service'); toggleMobileMenu()">
                  Deals on bookings
                </a>
              </div>
            </div>

            <!-- SERVICE PROVIDER: Requested Service, Transaction History, Deals, Payment, Services -->
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('service-provider-request-services'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'service-provider-request-services' }"
            >
              <i class="fa fa-wrench"></i>
              <span>Requested Service</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              [routerLink]="['/transaction-history']"
              (click)="toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'transaction-history' }"
            >
              <i class="fa fa-file-text"></i>
              <span>Transaction History</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('service-provider-deals-to-customer'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'service-provider-deals-to-customer' }"
            >
              <i class="fa fa-gift"></i>
              <span>Deals</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('service-provider-payment-from-customers'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'service-provider-payment-from-customers' }"
            >
              <i class="fa fa-history"></i>
              <span>Payment</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'SERVICE_PROVIDER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('services'); setServicesMenuClick(); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'services' }"
            >
              <i class="fa fa-cogs"></i>
              <span>Services</span>
            </a>

            <!-- RETAILER: Product, Orders, Deals, Payment, Transaction History -->
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('retailer-product-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'retailer-product-list' }"
            >
              <i class="fa fa-cube"></i>
              <span>Product</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'"
              [routerLink]="['/transaction-history']"
              (click)="toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'transaction-history' }"
            >
              <i class="fa fa-file-text"></i>
              <span>Transaction History</span>
            </a>
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('retailer-order-list'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'retailer-order-list' }"
            >
              <i class="fa fa-first-order"></i>
              <span>Orders</span>
            </a>
            <div class="mobile-account-section" *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'">
              <div class="mobile-account-header" (click)="toggleMobileBookingsMenu()">
                <i class="fa fa-wrench"></i>
                <span>Bookings</span>
                <i class="fa fa-chevron-down" [class.rotate]="isMobileBookingsMenuOpen"></i>
              </div>
              <div class="mobile-account-dropdown" [class.open]="isMobileBookingsMenuOpen">
                <a class="mobile-account-link" (click)="menuNavigateTo('customer-service-list'); toggleMobileMenu()">
                  Category
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('deal-service-list'); toggleMobileMenu()">
                  My Bookings History
                </a>
              </div>
            </div>
            
            <div class="mobile-account-section" *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'">
              <div class="mobile-account-header" (click)="toggleMobileRetailerPaymentMenu()">
                <i class="fa fa-credit-card"></i>
                <span>Payment</span>
                <i class="fa fa-chevron-down" [class.rotate]="isMobileRetailerPaymentMenuOpen"></i>
              </div>
              <div class="mobile-account-dropdown" [class.open]="isMobileRetailerPaymentMenuOpen">
                <a class="mobile-account-link" (click)="menuNavigateTo('reatiler-payment-customer'); toggleMobileMenu()" [ngClass]="{ active: activebar == 'reatiler-payment-customer' }">
                  Payment from customer
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('reatiler-payment-wholesaler'); toggleMobileMenu()" [ngClass]="{ active: activebar == 'reatiler-payment-wholesaler' }">
                  Payment to wholesalers
                </a>
              </div>
            </div>
            <div class="mobile-account-section" *ngIf="isLoggedIn && loggedInUserType == 'RETAILER' && SharingData && userRequestStatus == 'APPROVED'">
              <div class="mobile-account-header" (click)="toggleMobileRetailerDealsMenu()">
                <i class="fa fa-gift"></i>
                <span>Deals</span>
                <i class="fa fa-chevron-down" [class.rotate]="isMobileRetailerDealsMenuOpen"></i>
              </div>
              <div class="mobile-account-dropdown" [class.open]="isMobileRetailerDealsMenuOpen">
                <a class="mobile-account-link" (click)="menuNavigateTo('retailer-deal-list'); toggleMobileMenu()" [ngClass]="{ active: activebar == 'retailer-deal-list' }">
                  Deals to Customer
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('customer-product-deal-list'); toggleMobileMenu()" [ngClass]="{ active: activebar == 'customer-product-deal-list' }">
                  Deals from Wholesaler
                </a>
                <a class="mobile-account-link" (click)="menuNavigateTo('deal-service'); toggleMobileMenu()" [ngClass]="{ active: activebar == 'deal-service' }">
                  Deals on Bookings
                </a>
              </div>
            </div>
            

            <!-- Cart -->
            <a
              class="mobile-nav-link"
              *ngIf="isLoggedIn && (loggedInUserType == 'CUSTOMER' || loggedInUserType == 'RETAILER') && SharingData && userRequestStatus == 'APPROVED'"
              (click)="menuNavigateTo('addtoCart-customer'); toggleMobileMenu()"
              [ngClass]="{ active: activebar == 'addtoCart-customer' }"
            >
              <i class="fa fa-shopping-cart"></i>
              <span>Cart</span>
              <span class="mobile-cart-badge" *ngIf="totalItemsInShoppingBag > 0">{{ totalItemsInShoppingBag }}</span>
            </a>
          </nav>
        </div>
      </div>
    </nav>
  </div>
</header>

<div
  class="modal fade"
  id="logoutModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered logout-modal-dialog" role="document">
    <div class="modal-content logout-modal-content">
      <div class="logout-modal-header">
        <button type="button" class="close-modal-btn" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      
      <div class="logout-modal-body">
        <div class="logout-icon-wrapper">
          <img
            class="logout-icon-img"
            src="assets/latest/logoutui.png"
            alt="logout icon"
          />
        </div>
        <h2 class="logout-modal-title">
          Are you sure you want to logout?
        </h2>
      </div>

      <div class="logout-modal-footer">
        <button type="button" class="btn logout-btn-cancel" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn logout-btn-confirm"
          data-dismiss="modal"
          routerLink="/login"
          (click)="logout()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
